import { useEffect } from 'react';
import FileViewer from 'react-file-viewer';
const Viewer = ({ fileType, filePath }) => {
    
    return <FileViewer
        key={filePath}
        fileType={fileType}
        filePath={filePath}
        errorComponent={<h1>Hubo un error</h1>}
    />
};
export default Viewer;